export default {
    EFETIVADO: 1,
    FABRICADO: 2,
    PREPARADO: 3,
    TRANSPORTE: 4,
    DISPONIVEL: 5,
    UTILIZACAO: 6,

    properties: {
        1: {
            status: 'Seu carro foi encomendado',
            mensagem: 'Oba! O primeiro passo foi dado! Recebemos o seu pedido!'
        },
        2: {
            status: 'Seu carro está sendo fabricado',
            mensagem: 'Tudo certo! Seu carro já está sendo fabricado pela montadora! O prazo para conclusão dessa etapa pode variar de acordo com cada fabricante.'
        },
        3: {
            status: 'Seu carro está sendo preparado',
            mensagem: 'Aguarde mais um pouco! Estamos fazendo as regularizações, emplacamento e conferências necessárias para entregar o carro para você.'
        },
        4: {
            status: 'Seu carro está a caminho',
            mensagem: 'Quase lá! Seu carro já está a caminho! Te avisaremos por e-mail quando seu carro chegar.'
        },
        5: {
            status: 'Seu carro chegou',
            mensagem: 'Pronto! Que boa notícia! Você já pode retirar o seu veículo! Você recebeu um e-mail com todos os detalhes da retirada e se tiver dúvidas, pode entrar em contato com a gente: meuatendimento@localiza.com / 0800 099 1001 / WhatsApp (31) 99910-1010.'
        },
        6: {
            status: 'Carro em uso',
            mensagem: 'Aproveite! Em caso de dúvidas, já sabe onde nos encontrar: meuatendimento@localiza.com / 0800 099 1001 / WhatsApp (31) 99910-1010.'
        }
    }
}